import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsAPI } from '../api';

const SettingsContext = createContext();

const CACHE_KEY = 'cinefora_settings';

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    // Try to load from localStorage first for instant display
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        return JSON.parse(cached);
      }
    } catch (error) {
      console.error('Error loading cached settings:', error);
    }
    
    // Default settings if cache not available
    return {
      site_name: 'Cinefora Sinemaları',
      contact_email: 'info@cinefora.com',
      contact_phone: '0850 200 20 20',
      footer_description: 'Türkiye\'nin önde gelen sinema zinciri.',
    };
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await settingsAPI.get();
        const newSettings = response.data;
        
        // Cache the settings
        localStorage.setItem(CACHE_KEY, JSON.stringify(newSettings));
        
        setSettings(newSettings);
      } catch (error) {
        console.error('Error loading settings:', error);
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, []);

  const refreshSettings = async () => {
    try {
      const response = await settingsAPI.get();
      const newSettings = response.data;
      localStorage.setItem(CACHE_KEY, JSON.stringify(newSettings));
      setSettings(newSettings);
    } catch (error) {
      console.error('Error refreshing settings:', error);
    }
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
